import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Icon from "@components/icon";

import styles from "./SubmenuDropdown.scss";

const cx = classnames.bind(styles);

const SubmenuDropdown = ({ items }) => (
  <div className={cx("dropdown")}>
    {items.map(({ label, icon = null, href, counter, onClick }) => (
      <a
        className={cx("dropdown-item")}
        onClick={onClick}
        key={label}
        href={href}
      >
        {!!icon && (
          <Icon name={icon} size="s" color="var(--glz-color-neutral-tone-5)" />
        )}
        <span
          className={cx("dropdown-item-label", { "with-counter": !!counter })}
        >
          {label}
        </span>
        {counter}
      </a>
    ))}
  </div>
);

SubmenuDropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      icon: PropTypes.string,
      counter: PropTypes.node,
      onClick: PropTypes.func,
    })
  ),
};

export default SubmenuDropdown;
